import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'
import { IUser } from 'redux/store/user/types'
import { ACTIONS, SUBJECTS } from './constants'
import {
  SavingGoalsAbilityBuilder,
  SavingGoalsAbility,
  PossibleAbilities,
  Conditions
} from './types'
import { ROLES } from 'features/Permission'

const SavingGoalsAbilityClass = Ability as AbilityClass<SavingGoalsAbility>

export const ability = new Ability<PossibleAbilities, Conditions>()

export default (user: IUser) => {
  const builder = new AbilityBuilder(SavingGoalsAbilityClass)

  if (user.role.includes('community')) {
    defineCommunityAbilities(builder, user)
  }
  return new Ability(builder.rules) as SavingGoalsAbility
}

const defineCommunityAbilities = (
  builder: SavingGoalsAbilityBuilder,
  user: IUser
) => {
  switch (user.role) {
    case ROLES.COMMUNITY_PRESIDENT:
      builder.can(ACTIONS.VIEW, SUBJECTS.SAVINGS_GOALS_COMMUNITY)
      builder.can(ACTIONS.EDIT, SUBJECTS.SAVINGS_GOALS_HS)
      builder.can(ACTIONS.VIEW, SUBJECTS.SAVINGS_GOALS_HISTORY)
      break
    case ROLES.CONTRACT_STEWARD:
    case ROLES.FINANCE:
    case ROLES.CLINICAL_COORDINATOR:
      builder.can(ACTIONS.VIEW, SUBJECTS.SAVINGS_GOALS_HS)
      break
    case ROLES.ANALYST:
    case ROLES.VICE_PRESIDENT:
      builder.can(ACTIONS.EDIT, SUBJECTS.SAVINGS_GOALS_HS)
      builder.can(ACTIONS.VIEW, SUBJECTS.SAVINGS_GOALS_HISTORY)
      break
    default:
      // TODO: adjust permissions for new roles
      builder.can(ACTIONS.EDIT, SUBJECTS.SAVINGS_GOALS_HS)
      builder.can(ACTIONS.VIEW, SUBJECTS.SAVINGS_GOALS_HISTORY)
  }
}
